import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const HistorialInventario = () => {
  const [registros, setRegistros] = useState([]);

  const historialRef = collection(db, 'historial');

  const obtenerHistorial = async () => {
    const data = await getDocs(historialRef);
    const ordenado = data.docs
      .map(doc => ({ ...doc.data(), id: doc.id }))
      .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    setRegistros(ordenado);
  };

  useEffect(() => {
    obtenerHistorial();
  }, []);

  return (
    <div style={{ padding: '20px', color: 'white' }}>
      <h2 style={{ fontSize: '1.8rem', marginBottom: '20px' }}>Historial de Inventario</h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {registros.map((item) => (
          <li
            key={item.id}
            style={{
              backgroundColor: '#1f1f1f',
              padding: '12px',
              borderRadius: '6px',
              marginBottom: '12px'
            }}
          >
            <span
              style={{
                fontWeight: 'bold',
                color: item.accion === 'agregado' ? '#28a745' : '#dc3545'
              }}
            >
              {item.accion.toUpperCase()}
            </span>{' '}
            - {item.nombre} (Código: {item.codigo || 'N/A'}) <br />
            <span style={{ fontSize: '0.9rem', color: '#ccc' }}>
              Cantidad: {item.cantidad} <br />
              Fecha: {new Date(item.fecha).toLocaleString()}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HistorialInventario;
